// export const apiUrl = 'http://localhost/AI-Prosys/aaly/api/';
export const apiUrl = 'https://aaly.mubarmj.com/api/';
// export const apiUrl = 'http://s.ameenu.com/aaly/api/';
//export const apiUrl = 'https://mubarmj.com/doroos4/api/';
//export const apiUrl = 'http://doroosbh.com/system/api/';
export const downloadPath = apiUrl + 'download/file/';

export const enDefualt = {
    date: 'dd/MM/yyyy',
    dateC: 'dd/mm/yy',
    time: 'HH:mm:ss',
    timeC: 'HH:mm:ss',
    datetime: 'dd/MM/yyyy HH:mm:ss',
    datetimeC: 'dd/MM/yyyy HH:mm:ss',
    dateM: 'DD/MM/YYYY',
    timeM: 'HH:mm:ss',
    datetimeM: 'DD/MM/YYYY HH:mm:ss',
};
export const arDefualt = {
    date: 'yyyy/MM/dd',
    dateC: 'yy/mm/dd',
    time: 'HH:mm:ss',
    timeC: 'HH:mm:ss',
    datetime: 'yyyy/MM/dd HH:mm:ss',
    datetimeC: 'yyyy/MM/dd HH:mm:ss',
    dateM: 'YYYY/MM/DD',
    timeM: 'HH:mm:ss',
    datetimeM: 'YYYY/MM/DD HH:mm:ss',
};


// WEBPACK FOOTER //
// ./src/app/shared/config.ts